import Vue from 'vue'
import Antd from 'ant-design-vue'
import App from './App'
import lodash from 'lodash'
import config from '@/config'
import 'bootstrap/dist/css/bootstrap.css'
import 'ant-design-vue/dist/antd.css'
import './styles/open-iconic/font/css/open-iconic-bootstrap.css'
import './styles/animate/animate.css'
import './styles/index.css'

// 引入 lodash, 使用方式 this.$_.each()...
Object.defineProperty(Vue.prototype, '$_', { value: lodash });

// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') {
//   require('@/mock')
// }

Vue.config.productionTip = false;
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config

Vue.use(Antd);

new Vue({
  render: h => h(App),
}).$mount('#app');
